import React from 'react';
import { styled } from '@leagueplatform/genesis-core';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import type {
  MasonryEngineDriver,
  MasonryEngineNode,
} from '@leagueplatform/masonry-engine';
import {
  FormsCenterMasonryDriver,
  FormsCenterMasonryRootNode,
} from 'config/forms-center.config';

/**
 * TECH DEBT: This is a hack that forces the flat list of items into a grid layout.
 * This code is fragile and only intended as a temporary fix until we properly
 * implement the grid using the masonry grid renderer.
 */
const MasonryGrid = styled('div', {
  // Masonry wraps each renderer in its own div. We need to traverse down the tree
  // until we get the element we need.
  '& > div > div > div': {
    display: 'grid',
    '@initial': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    '@desktop': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    '@laptop': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    '@tablet': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '@mobileLandscape': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '@mobile': {
      gridTemplateColumns: 'repeat(1, 1fr)',
    },
  },
  '& :has(> h3)': {
    // Make the headers span the full grid width
    gridColumn: '1/-1',
  },
});

interface FormsCenterMasonryGridProps {
  className?: string;
  driver?: MasonryEngineDriver<any, any, any>;
  rootNode?: MasonryEngineNode;
}

export const FormsCenterMasonryGrid: React.FC<FormsCenterMasonryGridProps> = ({
  className,
  driver = FormsCenterMasonryDriver,
  rootNode = FormsCenterMasonryRootNode,
}) => (
  <MasonryGrid
    className={className}
    css={{
      paddingTop: '$three',
      paddingBottom: '$five',
      width: '100%',
    }}
  >
    <MasonryEngine driver={driver} rootNode={rootNode} />
  </MasonryGrid>
);
